/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResourceFilterName } from './ResourceFilterName';
import {
    ResourceFilterNameFromJSON,
    ResourceFilterNameFromJSONTyped,
    ResourceFilterNameToJSON,
    ResourceFilterNameToJSONTyped,
} from './ResourceFilterName';

/**
 * 
 * @export
 * @interface WidgetResourceFilterRepresentation
 */
export interface WidgetResourceFilterRepresentation {
    /**
     * 
     * @type {ResourceFilterName}
     * @memberof WidgetResourceFilterRepresentation
     */
    name: ResourceFilterName;
    /**
     * comma separated list | single value | range a-b
     * @type {string}
     * @memberof WidgetResourceFilterRepresentation
     */
    filter: string;
}



/**
 * Check if a given object implements the WidgetResourceFilterRepresentation interface.
 */
export function instanceOfWidgetResourceFilterRepresentation(value: object): value is WidgetResourceFilterRepresentation {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('filter' in value) || value['filter'] === undefined) return false;
    return true;
}

export function WidgetResourceFilterRepresentationFromJSON(json: any): WidgetResourceFilterRepresentation {
    return WidgetResourceFilterRepresentationFromJSONTyped(json, false);
}

export function WidgetResourceFilterRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetResourceFilterRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'name': ResourceFilterNameFromJSON(json['name']),
        'filter': json['filter'],
    };
}

export function WidgetResourceFilterRepresentationToJSON(json: any): WidgetResourceFilterRepresentation {
    return WidgetResourceFilterRepresentationToJSONTyped(json, false);
}

export function WidgetResourceFilterRepresentationToJSONTyped(value?: WidgetResourceFilterRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': ResourceFilterNameToJSON(value['name']),
        'filter': value['filter'],
    };
}

